(function () {
    var PLUS = document.getElementById('cl-footer-plus');

    /* Dựng lại đúng bộ khung của block menu (xem blocks/menu.liquid) để thừa
       hưởng toàn bộ CSS sẵn có, kể cả hiệu ứng đóng/mở và dấu + xoay. */
    function buildAccordion(heading, links) {
      var host = document.createElement('accordion-custom');
      host.className = 'menu';
      host.setAttribute('open-by-default-on-desktop', '');
      host.setAttribute('open-by-default-on-mobile', '');
      host.setAttribute('data-disable-on-desktop', 'true');
      host.setAttribute('data-disable-on-mobile', 'true');

      var details = document.createElement('details');
      details.className = 'menu__details spacing-style';
      details.open = true;
      details.style.setProperty('--spacing--size', '8px');

      var summary = document.createElement('summary');
      summary.className = 'menu__heading h6';

      var plain = document.createElement('span');
      plain.className = 'menu__heading__default';
      plain.textContent = heading;

      var collapsible = document.createElement('span');
      collapsible.className = 'menu__heading__accordion';
      collapsible.appendChild(document.createTextNode(heading));

      var toggle = document.createElement('span');
      toggle.className = 'menu__heading__toggle svg-wrapper icon-plus';
      if (PLUS) toggle.appendChild(PLUS.content.cloneNode(true));
      collapsible.appendChild(toggle);

      summary.appendChild(plain);
      summary.appendChild(collapsible);

      var nav = document.createElement('nav');
      nav.className = 'details-content';
      nav.setAttribute('aria-label', heading);

      var list = document.createElement('ul');
      list.className = 'list-unstyled';
      links.forEach(function (link) {
        var item = document.createElement('li');
        item.className = 'menu__item paragraph';
        var a = document.createElement('a');
        a.href = link.getAttribute('href');
        a.textContent = link.textContent.trim();
        item.appendChild(a);
        list.appendChild(item);
      });
      nav.appendChild(list);
      details.appendChild(summary);
      details.appendChild(nav);
      host.appendChild(details);
      return host;
    }

    function convert() {
      /* Trong trình sửa giao diện thì để nguyên: chuyển đổi này thay hẳn hai
         khối text bằng markup mới, mất luôn shopify_attributes — admin bấm vào
         cột link sẽ không chọn được block để sửa nữa. */
      if (window.Shopify && window.Shopify.designMode) return;

      var footer = document.querySelector('footer .footer-content');
      if (!footer) return;

      var columns = footer.querySelectorAll('.group-block-content');
      Array.prototype.forEach.call(columns, function (column) {
        if (column.dataset.clFooterMenu) return;

        var title = column.querySelector(':scope > .text-block.h6');
        var body = column.querySelector(':scope > .text-block.rte');
        if (!title || !body) return;

        var links = body.querySelectorAll('a[href]');
        /* Đúng hai cột link mới có nhiều link trong một text block. Khối liên
           hệ cũng là tiêu đề + rich text, nhưng bên trong là câu chữ chứ không
           phải danh sách — đừng đụng vào. */
        if (links.length < 2) return;

        column.dataset.clFooterMenu = '1';
        column.replaceChildren(buildAccordion(title.textContent.trim(), links));
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', convert);
    } else {
      convert();
    }
  })();
